export enum holdingCompanyFormFields {
  ticker = 'ticker',
  nameEn = 'nameEn',
  nameAr = 'nameAr',
  logoUrl = 'logoUrl',
  website = 'website',
}
